import { render, staticRenderFns } from "./PriceDescriptionModal.vue?vue&type=template&id=cbd04266&scoped=true&"
import script from "./PriceDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./PriceDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceDescriptionModal.vue?vue&type=style&index=0&id=cbd04266&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd04266",
  null
  
)

export default component.exports